export const commonTranslationsNL = {
    addBtn: 'Voeg toe',
    addressLabel: 'Adres',
    cancel: 'Annuleer',
    cityLabel: 'Stad',
    confirm: 'Bevestig',
    comments: 'Commentaar',
    contactInformation: 'Contactinformatie',
    contactLabel: 'Contact',
    contactsAdd: 'Voeg contact toe',
    foodRestrictionAdd: 'Voeg voedselrestrictie toe',
    countryLabel: 'Land',
    'creation-successful': 'Succesvol aangemaakt',
    BOOLEAN: 'Ja/nee vraag',
    AMOUNT: 'Aantal',
    data: 'Gegevens',
    date: 'Datum',
    delete: 'Verwijder',
    edit: 'Pas aan',
    goBack: 'Ga terug naar de vorige pagina',
    nameLabel: 'Naam',
    noInfo: 'Geen gegevens beschikbaar.',
    numberLabel: 'Nummer',
    boxLabel: 'Busnummer',
    ok: 'Ok',
    organisation: 'Organisatie',
    pageNotFoundErr: 'Deze pagina kon niet worden gevonden.',
    postalCodeLabel: 'Postcode',
    save: 'Opslaan',
    search: 'Zoek',
    'something-went-wrong': 'Er ging iets mis',
    streetLabel: 'Straat',
    'update-successful': 'Succesvol aangepast',
    logIn: 'Inloggen',
    logOut: 'Uitloggen',
    documentation: 'Documentatie',
    forbiddenTitle: 'Verboden toegang',
    forbiddenText: 'Je hebt onvoldoende rechten voor het uitvoeren van de laatste actie.',
    active: 'Actief tot',
    futureSupportPeriod: ' - Nieuwe periode vanaf {{date}}',
    lastVisit: 'Laatste bezoek {{supportType}}',
    notFound: 'Niet gevonden',
    notActive: 'Niet Actief',
    notFoundTitle: 'Pagina niet gevonden',
    notFoundText: 'Oeps... Deze pagina bestaat niet.',
    backButton: 'Ga terug naar vorige pagina',
    unknown: 'Onbekend',
    createdDate: 'Aanmaakdatum',
    createdBy: 'Aangemaakt door',
    tryAgainLater:
        'Probeer later nog eens, indien deze foutmelding zich opnieuw voordoet: contacteer de verantwoordelijke.',
    networkErrorTitle: 'Verbindingsfout',
    networkErrorText: 'We konden je aanvraag niet verwerken.\nHerlaad je pagina en probeer opnieuw.',
    previous: 'Vorige',
    next: 'Volgende',
    complete: 'Voltooi',
    yes: 'Ja',
    no: 'Nee',
    general: 'Algemeen',
    contact: 'Contact',
    noRows: 'Geen gegevens gevonden.',
    actions: 'Acties',
    columnMenuHideColumn: 'Verberg kolom',
    columnMenuManageColumns: 'Beheer kolommen',
    columnMenuSortAsc: 'Sorteer oplopend',
    columnMenuSortDesc: 'Sorteer aflopend',
    columnsManagementShowHideAllText: 'Toon/Verberg alle',
    testingEnvironment: 'Dit is de testomgeving.',
};
